import {get} from './http';
import AppActions from './../actions/AppActions';

export default function fetchLookups() {
    const l = [
        'SiteName',
        'SiteType',
        'Region',
        'Hazards',
        'IncidentType',
        'IsInjury',
        'IncidentRiskRating',
        'ActivityTaskInvolved',
        'ConsequenceDescription',
        'Consequence',
        'IncidentCategory',
        'IncidentSubCategory',
        'IncidentLevel',
        'InjuryType',
        'InjuryTypeShort',
        'InjuryBodyPart',
        'InjuryConsequence'
    ];

    get('api/incidents/lookups', {l}, (lookups) => {
        AppActions.updateStates([
            {statePath: 'lookups', data: lookups}
        ]);
    });
}
